import { Item } from "../items/Item";
import Character, { ICharacterStats } from "../characters/Character";
import { ICurrensy } from "../inventory/Inventory";

export class Enemy extends Character {
    private loot: Item[]
    private currensy: ICurrensy
    public isLooted: boolean

    constructor(enemieStats: ICharacterStats, currensy: ICurrensy) {
        super(enemieStats)
        this.loot = []
        this.currensy = currensy
        this.isLooted = false
    }

    getLoot() {
        return this.loot[Math.round(Math.random() * (this.loot.length - 0 + 1) + 0)]
    }

    getCurensy() {
        const item: ICurrensy = {
            name: "bones",
            images: { webp: "", img: "" },
            amount: Math.round(Math.random() * (10 - 1 + 1) + 1)
        }

        return item
    }

    getExp() {
        return Math.round(Math.random() * (50 - 10 + 1) + 10)
    }
    
    setLooted() {
        this.isLooted = true
    }

}